import React, { useState, useEffect } from 'react';
import { telegramService } from '../services/telegramService';

function TelegramTest({ students = [], onUpdateStudent }) {
  const [chatId, setChatId] = useState('');
  const [message, setMessage] = useState('Test mesajı 🤖');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [registeredUsers, setRegisteredUsers] = useState([]);

  useEffect(() => {
    fetchRegisteredUsers();
  }, []);

  const fetchRegisteredUsers = async () => {
    try {
      const isProduction = window.location.hostname !== 'localhost';
      if (isProduction) {
        // Production'da bu özellik yok
        setRegisteredUsers([]);
        return;
      }
      
      const response = await fetch('http://localhost:3001/api/registered-users');
      const data = await response.json();
      setRegisteredUsers(data.users || []);
    } catch (error) {
      console.error('Kayıtlı kullanıcılar alınamadı:', error);
      setRegisteredUsers([]);
    }
  };

  const sendTestMessage = async () => {
    if (!chatId || !message) {
      alert('Chat ID ve mesaj gerekli!');
      return;
    }

    setLoading(true);
    try {
      const result = await telegramService.sendMessage(chatId, message);
      setResult(result);
    } catch (error) {
      setResult({ success: false, error: error.message });
    }
    setLoading(false);
  };

  const assignChatIdToStudent = () => {
    if (!selectedStudent || !chatId) {
      alert('Öğrenci ve Chat ID seçin!');
      return;
    }
    
    if (onUpdateStudent) {
      onUpdateStudent(selectedStudent, { parentTelegram: chatId });
      alert(`Chat ID ${selectedStudent} öğrencisine atandı!`);
      setSelectedStudent('');
      setChatId('');
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>🤖 Telegram Bot Test</h2>
      
      {registeredUsers.length > 0 && (
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#e7f3ff', borderRadius: '8px' }}>
          <h3>👥 Bot'a Kayıtlı Kullanıcılar ({registeredUsers.length})</h3>
          {registeredUsers.map((user, index) => (
            <div key={index} style={{ 
              padding: '10px', 
              marginBottom: '10px', 
              backgroundColor: 'white', 
              borderRadius: '5px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <strong>{user.firstName} {user.lastName}</strong>
                <div style={{ fontSize: '12px', color: '#666' }}>ID: {user.chatId}</div>
              </div>
              <button
                onClick={() => setChatId(user.chatId.toString())}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Kullan
              </button>
            </div>
          ))}
        </div>
      )}

      {students.length > 0 && chatId && (
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px' }}>
          <h3>📌 Chat ID'yi Öğrenciye Ata</h3>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <select
              value={selectedStudent}
              onChange={(e) => setSelectedStudent(e.target.value)}
              style={{ flex: 1, padding: '8px', borderRadius: '4px' }}
            >
              <option value="">Öğrenci Seç...</option>
              {students.map(s => (
                <option key={s.name} value={s.name}>{s.name}</option>
              ))}
            </select>
            <button
              onClick={assignChatIdToStudent}
              style={{
                padding: '8px 15px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Ata
            </button>
          </div>
        </div>
      )}
      
      <div style={{ marginBottom: '15px' }}>
        <label>Chat ID:</label>
        <input
          type="text"
          value={chatId}
          onChange={(e) => setChatId(e.target.value)}
          placeholder="123456789"
          style={{ width: '100%', padding: '8px', marginTop: '5px' }}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label>Mesaj:</label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={4}
          style={{ width: '100%', padding: '8px', marginTop: '5px' }}
        />
      </div>

      <button 
        onClick={sendTestMessage}
        disabled={loading}
        style={{
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Gönderiliyor...' : '📤 Test Mesajı Gönder'}
      </button>

      {result && (
        <div style={{
          marginTop: '20px',
          padding: '15px',
          borderRadius: '5px',
          backgroundColor: result.success ? '#d4edda' : '#f8d7da',
          border: `1px solid ${result.success ? '#c3e6cb' : '#f5c6cb'}`
        }}>
          <h4>{result.success ? '✅ Başarılı!' : '❌ Hata!'}</h4>
          <pre style={{ fontSize: '12px', overflow: 'auto' }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}

      <div style={{ marginTop: '30px', fontSize: '14px', color: '#666' }}>
        <h4>💡 Nasıl Kullanılır:</h4>
        <ol>
          <li>Telegram'da @BotFather ile bot oluşturun</li>
          <li>Bot token'ı .env dosyasına ekleyin</li>
          <li>Veli ile bot arasında mesaj gönderip chat ID alın</li>
          <li>Chat ID'yi yukarıya yazıp test edin</li>
        </ol>
      </div>
    </div>
  );
}

export default TelegramTest;